(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-bill-item"
      }, [_vm.$slots.icon ? _c('div', {
        staticClass: "item-icon"
      }, [_vm._t("icon")], 2) : _vm._e(), _c('div', {
        class: [_vm.comTitle && _vm.$slots.icon ? 'item-content' : '', _vm.comTitle && !_vm.$slots.icon ? 'item-title' : '', !_vm.comTitle && !_vm.$slots.icon ? 'content-item' : '', !_vm.comTitle && _vm.$slots.icon ? 'item-content-notitle' : '']
      }, [_vm.name ? _c('div', {
        staticClass: "nx-bill-item-title"
      }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm.$slots.name && !_vm.name ? _c('div', {
        staticClass: "nx-bill-item-title"
      }, [_vm._t("name")], 2) : _vm._e(), _vm.title ? _c('div', {
        staticClass: "nx-bill-item-tip"
      }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.$slots.title && !_vm.title ? _c('div', {
        staticClass: "nx-bill-item-tip"
      }, [_vm._t("title")], 2) : _vm._e(), _vm.date ? _c('div', {
        staticClass: "nx-bill-item-time",
        class: [_vm.status ? '' : 'status-item']
      }, [_vm._v("\n      " + _vm._s(_vm.date) + "\n    ")]) : _vm._e()]), _c('div', {
        class: [_vm.comTitle ? 'item-money' : 'sub-item', !_vm.comTitle && _vm.$slots.icon ? 'sub-item-notitle' : '']
      }, [_vm.money ? _c('div', {
        staticClass: "nx-bill-item-money",
        class: {
          'nx-bill-item-income': _vm.type === 'income',
          'nx-bill-item-pay': _vm.type === 'pay'
        }
      }, [_vm._v("\n      " + _vm._s(_vm.money) + "\n    ")]) : _vm._e(), _vm.status ? _c('div', {
        staticClass: "nx-bill-item-pay-status",
        class: {
          'nx-bill-item-trading': _vm.trading === 'failure'
        }
      }, [_vm._v("\n      " + _vm._s(_vm.status) + "\n    ")]) : _vm._e()])]);
    },
    name: 'nx-bill-item',
    props: {
      name: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      date: {
        type: String,
        default: ''
      },
      money: {
        type: String,
        default: ''
      },
      status: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      },
      trading: {
        type: String,
        default: ''
      }
    },
    data: function data() {
      return {
        comTitle: this.title || this.$slots.title
      };
    },
    mounted: function mounted() {
      this.comTitle = this.title || this.$slots.title;
    }
  };
  _exports.default = _default;
});